import { createAsyncThunk } from "@reduxjs/toolkit";
import { Layout } from "react-grid-layout";
import { generateAndUpdateDefaultLayoutForDashboardByIdThunk } from "./generateAndUpdateDefaultLayoutForDashboardByIdThunk";
import { setCurrentDashboardId } from "../../dashboardsSlice";
import { DashboardLayoutBreakpoint } from "../../utils/types/types";
import { enqueueSnackbarErrorAlert } from "@/components/pages/common/snackbar-alert/EnqueueSnackbarErrorAlert";
import { getDashboardByIdThunk } from "@/store/dashboards/thunks/dashboard/getDashboardByIdThunk";

export const getDashboardByIdAndUpdateLayoutThunk = createAsyncThunk(
  "dashboards/getDashboardByIdAndUpdateLayout",
  async (dashboardId: string, { dispatch }) => {
    try {
      const response = await dispatch(
        getDashboardByIdThunk(dashboardId),
      ).unwrap();

      const layout = response.layout as
        | Record<DashboardLayoutBreakpoint, Layout>
        | undefined;

      if (
        (!layout?.lg || !layout.md || !layout.sm) &&
        response.widgets.length
      ) {
        dispatch(generateAndUpdateDefaultLayoutForDashboardByIdThunk(response));
      }

      dispatch(setCurrentDashboardId(response.id));
    } catch (e) {
      // @ts-expect-error todo: fix api spec;
      enqueueSnackbarErrorAlert(e?.data?.message);
    }
  },
);
